import * as React from "react";
import { Tooltip as ToolTip } from "@octopusdeploy/design-system-components";
import {QuestionCircleIcon} from "@octopusdeploy/design-system-icons";

export class ToolTipIcon extends React.Component<{ description: string }> {
    render() {
        const {description} = this.props;
        return <ToolTip content={description}>
            <QuestionCircleIcon size={16}/>
        </ToolTip>;
    }
}
